import { render } from "./ScoreAction.vue?vue&type=template&id=3de7a6e2&scoped=true"
import script from "./ScoreAction.vue?vue&type=script&lang=js"
export * from "./ScoreAction.vue?vue&type=script&lang=js"

import "./ScoreAction.vue?vue&type=style&index=0&id=3de7a6e2&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3de7a6e2"]])

export default __exports__